<template>
  <div ref="imgcontainer" style="display:flex;height:80vh;" @click="replyComments(null)">
    <template v-if="detail.media_list">
      <div v-if="detail.media_list[0].type=='video'" class="video-wrapper">
        <div id="videoplayer" style="width:616px;height:100%;"></div>
      </div>
      <div v-else class="imgdivwrapper" :style="{ width: containerWidth + 'px' }">
        <el-carousel v-if="detail.media_list.length>1" indicator-position="none" class="article-caroul" :autoplay="false" style="height:100%;" @change="caroulChange">
            <el-carousel-item v-for="(item,index) in detail.media_list" :key="index">
              <img @load="handleImageLoad($event,index)" @error="handleImageError" referrerpolicy="no-referrer" :src="item.url" style="width:100%;height:100%;object-fit: contain;border-radius: 3px;"/>
            </el-carousel-item>
          </el-carousel>
          <div v-else>
              <img @load="handleImageLoad($event,0)" @error="handleImageError" referrerpolicy="no-referrer" :src="detail.media_list[0].url" style="width:100%;height:100%;object-fit: contain;border-radius: 3px;"/>
          </div>
          <div v-if="detail.media_list.length>1" style="z-index: 999;position:absolute;top:10px;right:10px;background:#ccc;color:white;border-radius: 3px;padding: 5px;">
            {{ imageIndex+1 }}/{{ detail.media_list.length }}
          </div>
      </div>
    </template>
    <div v-if="detail.content || detail.title" style="width:440px;padding:24px;position: relative;border-left:1px solid rgba(0, 0, 0, 0.08)">
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div style="display: flex;align-items: center;">
          <template v-if="detail.type!='0'">
            <img v-if="detail.merchant_info && detail.merchant_info.country" :src="`https://pic.joyorders.com/country/${detail.merchant_info.country.toLowerCase()}.png`" style="width:40px;height:40px;margin-right:10px;object-fit: contain;"/>
            <img v-else src="../assets/images/offlinePic.png" style="width:40px;height:40px;border-radius:20px;margin-right:10px;object-fit: contain;"/>
          </template>
          <template v-else>
            <template v-if="detail.account_profile">
              <img :src="detail.account_profile" style="width:40px;height:40px;border-radius:20px;margin-right:10px;"/>
            </template>
            <template v-else>
              <img src="../assets/images/avatar@2x.png" style="width:40px;height:40px;border-radius:20px;margin-right:10px;"/>
            </template>
          </template>
          <template v-if="detail.type!='0'">
            <label style="font-size:16px;">{{ detail.merchant_info && (detail.merchant_info.name || detail.merchant_info.name_en)?(detail.merchant_info.name || detail.merchant_info.name_en):'未知商家' }}</label>
          </template>
          <template v-else>
            <label style="font-size:16px;">{{ (detail.account_nickname || detail.account_name) }}</label>
          </template>
        </div>
        <div v-if="detail.type!='11' && detail.type!='12'">
          <el-button class="btn-14 nohover" :type="followed?'default':'info'" style="width:90px;height:38px;" @click="toggleFollow">
            {{ followed?'已关注':'关注' }}
          </el-button>
        </div>
      </div>
      <div class="right-article-detail">
        <h3 style="margin-bottom: 8px;font-weight: 600;font-size: 18px;margin-top:24px;">
          {{ detail.title }}
        </h3>
        <p class="article-content" v-html="article_content"></p>
        <div style="padding:10px 0;font-size:12px;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #f6f6f6;">
          <div>
            {{ generateDateDisplay(detail.create_time) }}{{ detail.location && detail.location.ip_province?' '+detail.location.ip_province:'' }}
          </div>
          <div v-if="is_community_administrator==1 || merchant_admin" style="cursor: pointer;" @click.stop="showHistory(articleId,'post')">
            <i class="el-icon-view" style="font-size: 16px;position: relative;top:1px;"></i> <label style="position:relative;top:0.5px;">{{ detail.views_count }}</label>
          </div>
        </div>
        <div style="display: flex;flex-wrap:wrap;">
          <template v-for="(item,index) in detail.good_list">
            <template v-if="detail.type==11 || detail.type==12">
              <div class="relation_product_big" @click="navToDetail(item)">
                <img :src="item.image_url" style="width:150px;height:150px;object-fit: contain;"/>
                <p class="product-name" style="margin:5px 0;font-size:12px;">
                  {{ item.name }}
                </p>
                <div>
                  <del v-if="item.price!='--' && item.price != item.discounted_price" style="font-size:9px;">{{item.currency_symbol}}{{item.price}}</del><span class="product-price" :class="{'discounted':item.price != item.discounted_price}">{{item.price!='--'?item.currency_symbol:''}}{{item.discounted_price}}</span><span v-if="item.price!='--'" style="font-size:9px;margin-left:3px;">{{ item.currency }}</span>
                </div>
                <div v-if="is_community_administrator==1 || merchant_admin" style="cursor: pointer;position: absolute;right: 6px;top: 0;line-height: 9px;" @click.stop="showHistory(item.post_good_id,'good')">
                  <i v-if="item.views_count && item.views_count!='0'" @click.stop="showHistory(item.post_good_id,'good')" class="el-icon-view" style="font-size:9px;" ></i>                
                  <span v-if="item.views_count && item.views_count!='0'" @click.stop="showHistory(item.post_good_id,'good')" style="font-size: 9px;">{{ item.views_count }}</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="relation_product" @click="navToDetail(item)">
                <img :src="item.image_url" style="width:48px;height:48px;object-fit: contain;margin-right:10px;"/>
                <div class="relation_product_info">
                  <p :title="item.name" class="product-name" style="margin:5px 0;">
                    {{ item.name }}
                  </p>
                  <div>
                    <del v-if="item.price!='--' && item.price != item.discounted_price" style="font-size:9px;">{{item.currency_symbol}}{{item.price}}</del><span class="product-price" :class="{'discounted':item.price != item.discounted_price}">{{item.price!='--'?item.currency_symbol:''}}{{item.discounted_price}}</span><span v-if="item.price!='--'" style="font-size:9px;margin-left:3px;">{{ item.currency }}</span>
                  </div>
                </div>
                <i class="el-icon-arrow-right" style="color:#C0C4CC"></i>
              </div>
            </template>
          </template>
        </div>
        <p style="margin-top: 12px;font-size: 14px;color:#aaa;">
          {{ formatDate(detail.create_time) +' ' + (detail.location?detail.location.name:'') }}
        </p>
        <div v-if="comments.length" style="color:#aaa;margin-top:24px;padding:16px 0;border-top: 1px solid rgba(0,0,0,0.08)">
          <p>共{{ ' '+detail.comments_count+' ' }}条评论</p>
        </div>
        <div v-if="comments.length">
          <div class="article-comment" v-for="(c,index) in comments" :key="index">
            <div>
              <template v-if="c.account_profile">
                <img :src="c.account_profile" style="width:40px;height:40px;border-radius:20px;margin-right:6px;"/>
              </template>
              <template v-else>
                <img src="../assets/images/avatar@2x.png" style="width:40px;height:40px;border-radius:20px;margin-right:6px;"/>
              </template>
            </div>
            <div>
              <p style="line-height:1.4;">{{ c.account_nickname || c.account_name }}</p>
              <p style="line-height:1.4;margin-top:4px;">{{ c.content }}</p>
              <p style="margin:8px 0;color:#aaa;">
                {{ formatDate(c.create_time) +' ' + c.location.name }}
              </p>
              <div style="display: flex;align-items: center;">
                <span style="margin-right:4px;display: flex;align-items: center;">
                  <img class="agree-icon" :class="{'animation':c.agreeclicked}" :src="c.agreeImageSrc" @click.stop="toggleLike(c,'comment')"/>
                  <label style="color:#888;font-size:12px">{{ c.likes_count!=0?c.likes_count:'赞' }}</label>
                </span>
                <span style="margin-left:8px;cursor: pointer;display: flex;align-items: center;" @click.stop="replyComments(c,'0',c.comment_id,index)">
                  <i class="el-icon-chat-round" style="margin-right:2px;"></i>
                  <label style="color:#888;cursor: pointer;font-size:12px">
                    {{ c.child_comments_count!=0?c.child_comments_count:'回复' }}
                  </label>
                </span>
              </div>
              <div v-if="c.child_comments_count!='0'" style="margin-top:16px;">
                <div class="article-comment" v-for="(r,chindren_index) in c.children" :key="chindren_index">
                  <div>
                    <template v-if="r.account_profile">
                      <img :src="r.account_profile" style="width:20px;height:20px;border-radius:10px;margin-right:6px;"/>
                    </template>
                    <template v-else>
                      <img src="../assets/images/avatar@2x.png" style="width:20px;height:20px;border-radius:10px;margin-right:6px;"/>
                    </template>
                  </div>
                  <div>
                    <p style="line-height:1.4;">{{ r.account_nickname || r.account_name }}</p>
                    <p style="line-height:1.4;">
                      <span style="margin-right:3px;color:#aaa;" v-if="r.parent_comment_id!=c.comment_id">
                        回复 {{ r.parent_account_name }}
                      </span>
                      {{ r.content }}
                    </p>
                    <p style="margin:8px 0;color:#aaa;">
                      {{ formatDate(r.create_time) +' ' + r.location.name }}
                    </p>
                    <div style="display: flex;align-items: center;">
                      <span style="margin-right:4px;display: flex;align-items: center;">
                        <img class="agree-icon" :class="{'animation':r.agreeclicked}" :src="r.agreeImageSrc" @click.stop="toggleLike(r,'comment')"/>
                        <label style="color:#888;font-size:12px;">{{ r.likes_count!=0?r.likes_count:'赞' }}</label>
                      </span>
                      <span style="margin-left:8px;cursor: pointer;display: flex;align-items: center;" @click.stop="replyComments(r,c.comment_id,r.comment_id,chindren_index)">
                        <i class="el-icon-chat-round" style="margin-right:2px;"></i>
                        <label style="color:#888;cursor:pointer;font-size:12px">回复</label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div style="display: flex;flex-direction: column;margin-top:40px;align-items: center;justify-content: center;border-top: 1px solid rgba(0,0,0,0.08);">
            <img src="../assets/images/nocomments.png" style="width:100px;height:100px;" />
            <p style="color:#aaa">还没有评论哦,<span @click="showReplyFull=true" style="cursor: pointer;color:#0f66cf">点击评论</span></p>
          </div>
        </div>
      </div>
      <div style="border-bottom-right-radius:3px;position: absolute;bottom: 0px;left:0px;width:100%;padding:16px 24px;background: white;border-top:1px solid rgba(0, 0, 0, 0.08)" @click="stopProp">
        <div v-if="showReplyFull && (current_comment.account_nickname || current_comment.account_name)" style="margin-bottom:12px;">
          <p>回复 {{ current_comment.account_nickname || current_comment.account_name }}:</p>
          <p style="margin-top:4px;">{{ current_comment.content }}</p>
        </div>
        <div style="display:flex;align-items: center;">
          <el-input ref="inputRef" @focus="showReplyFull=true" v-model="newMessage" style="flex:1;margin-right:10px;" placeholder="说点什么..."/>
          <template v-if="!showReplyFull">
            <span style="margin:0 5px;display: flex;align-items: center;">
              <img class="agree-icon big" :class="{'animation':agreeclicked}" :src="agreeImageSrc" @click="toggleLike(detail,'post')"/>
              <label style="color:#888">{{ detail.likes_count }}</label>
            </span>
            <span style="margin:0 5px;display: flex;align-items: center;">
              <img class="agree-icon big" :class="{'animation':collectclicked}" :src="collectImageSrc" @click="toggleCollect"/>
              <label style="color:#888">{{ detail.collections_count }}</label>
            </span>
            <span style="margin-left:5px;font-size:24px;display: flex;align-items: center;">
              <img src="../assets/images/comment.png" style="margin-right:2px;width:24px;height:24px;cursor: pointer;" @click="replyComments(null)"/>
              <label style="color:#888">{{ detail.comments_count }}</label>
            </span>
          </template>
        </div>
        <div v-if="showReplyFull" style="display: flex;justify-content: space-between;">
          <div style="margin-top:10px;">
            <el-popover
              placement="top"
              width="370"
              trigger="click">
              <emoji-picker @emoji="insertEmoji" ref="emojiPicker"></emoji-picker>
              <div class="emoji-wrapper">
                    <div v-for="(emojiGroup, category) in emojis" :key="category">
                      <template v-if="category!='Frequently used'">
                        <h5 style="margin:8px 4px;">{{ getCategory(category) }}</h5>
                        <div style="display: flex;justify-content: flex-start;flex-wrap: wrap;">
                          <span v-for="(emoji, emojiName) in emojiGroup"
                              :key="emojiName"
                              @click="insertEmoji(emoji)"
                              :title="chineseNames[emojiName]"
                              class="emoji-item">
                          {{ emoji }}
                          </span>
                        </div>
                      </template>
                    </div>
                </div>
              <el-button style="padding:0;transform: scale(1.5);" type="text" slot="reference">😀</el-button>
            </el-popover>
          </div>
          <div style="display:flex;justify-content: flex-end;margin-top: 10px;">
            <el-button class="btn-14" type="info" style="width:90px;height:38px;" @click="reply">
              发送
            </el-button>
            <el-button class="btn-14 el-button nohover" type="default" style="width:90px;height:38px;" @click.stop="showReplyFull=false;">
              取消
            </el-button>
          </div>
        </div>
        <!--<div v-if="showReplyFull" style="display:flex;justify-content: flex-end;margin-top: 10px;">
          <el-button class="btn-14" type="info" style="width:90px;height:38px;" @click="reply">
            发送
          </el-button>
          <el-button class="btn-14 el-button nohover" type="default" style="width:90px;height:38px;" @click.stop="showReplyFull=false;">
            取消
          </el-button>
        </div>-->
      </div>
    </div>
    <el-dialog top="0" :append-to-body="true" v-if="historyVisible" class="el-dialog-sm custom-width-dialog" :close-on-click-modal="false" :visible.sync="historyVisible" width="600px">
      <div style="background: white;">
      <h3 class="text-center">浏览记录</h3>
      <div class="history-row">
        <div style="width:50%;">
          用户
        </div>
        <div style="flex:1">
          浏览时间
        </div>
      </div>
      <div style="position: relative;">
        <div class="history-body" v-if="historyRecords.length" 
    :infinite-scroll-immediate="false"
    v-infinite-scroll="loadMoreHistory"
    :infinite-scroll-disabled="!hasMoreHistory || loadingHistory">         
          <div class="history-row" v-for="(item,index) in historyRecords" :key="index">
            <div style="width:50%;">
              {{ item.username }}
            </div>
            <div style="flex:1">
              {{ item.create_time }}
            </div>
          </div>
        </div>
        <div v-if="continueSearching" style="position:absolute;bottom:0;left:0;height:20px;width:100%;text-align: center;">
          <i class="el-icon-loading"></i>
        </div>
      </div>
      
      <div>
        <el-button style="margin:20px 0;" class="block nohover" type="default" @click="historyVisible=false">关 闭</el-button>
      </div>
      </div>
    </el-dialog>

    <el-dialog v-if="productDetailVisible" top="0" class="el-dialog-sm custom-width-dialog-90p no-padding" :show-close="false" :visible.sync="productDetailVisible" width="auto">
      <PRODUCT :productId="product_id" :merchantId="merchant_id"></PRODUCT>
    </el-dialog>
  </div>
</template>

<script>
import api from '../services/api.js'
import PRODUCT from "../components/ProductDetail"
import Player,{ Plugin } from 'xgplayer';
import 'xgplayer/dist/index.min.css';

import { getCategoryName,chineseNames } from '../services/tools.js'
import EmojiPicker from 'vue-emoji-picker';

export default {
  name: 'HelloWorld',
  created() {
    if (document.body.clientWidth < 1024) {
      this.mobiletype = true
    }
  },
  components: {
    PRODUCT:PRODUCT,
    EmojiPicker,
  },
  data () {
    return {
      emojis:[],
      chineseNames:chineseNames,
      productDetailVisible:false,
      continueSearching:false,
      current_history_id:'',
      current_history_type:'',
      currentPage:1,
      loadingHistory: false,
      hasMoreHistory: true,
      historyVisible:false,
      historyRecords:[],
      agreeImageSrc:'',
      collectImageSrc:'',
      agreeclicked:false,
      collectclicked:false,
      showReplyFull:false,
      article_id:'',
      detail:{},
      newMessage:'',
      comments:[],
      current_comment_index:-1,
      location:{},
      imageIndex:0,
      followed:false,
      article_content:'',
      current_comment:{},
      top_comment_id:'0',
      parent_comment_id:'0',
      containerWidth:0,
      is_community_administrator:this.$localStorage.get('is_community_administrator'),
      account_id:this.$localStorage.get('account_id'),
      merchant_admin:false,
      product_id:'',
    }
  },
  props:['articleId'],
  watch: {
    // 监听外部 value 的变化，用于 v-model 的同步
    showReplyFull(newVal) {
      if (newVal) {
        this.$nextTick(()=>{
          const picker = this.$refs.emojiPicker
        const picker1 = this.$refs.emojiPicker1
        console.log('emoji1',picker,picker1)
        if (picker && picker.emojis) {
          console.log('emoji',picker,picker.emojis)
          this.emojis = picker.emojis
        }
        })
        
      }
    }
  },
  mounted() {
    this.getLocation();
    this.getDetail();
    
  },
  methods:{
    getCategory(category){
      return getCategoryName(category)
    },
    showHistory(id,type){
      this.historyRecords=[];
      this.current_history_id=id;
      this.current_history_type=type;
      this.historyVisible=true;
      this.hasMoreHistory = true;
      this.loadingHistory = false;
      this.getHistory(id,type,true);
    },
    navToDetail(item){
      switch(item.type){
        case 'url':
          if(item.good_id && item.good_id!='0'){
            let url = '/product?id='+item.good_id;
            if(item.merchant_id)
              url+='&mid='+item.merchant_id
            window.open(url)
          }
          else
            window.open(item.url);
          break;
        default:
          let url = '/product?id='+item.good_id;
          if(item.merchant_id)
            url+='&mid='+item.merchant_id
          window.open(url)
          break;
      }
    },
    handleImageLoad(event,index) {
      if(index==0){
        const img = event.target;
        const container = this.$refs.imgcontainer;
        const actualHeight = container.clientHeight; // 获取容器实际像素高度
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        this.containerWidth = actualHeight * aspectRatio;
      }
    },
    stopProp(e){
      e.stopPropagation();
    },
    search(){
      
    },
    async getHistory(id,type,needReload){
      // 防止重复请求
      if (this.loadingHistory || (!needReload && !this.hasMoreHistory)) {
        return;
      }
      this.loadingHistory = true;

      const generateParams=(needReload)=>{
        let params={}
        params.limit=10;
        if(needReload){
          params.page=1;
          this.currentPage = 1;
        }
        else{
          this.currentPage++;
          params.page=this.currentPage;
          this.continueSearching=true;
        }
        return params
      }
      let data=generateParams(needReload);
      let url = type=='post'?'get_post_view_history_list':'get_post_view_history_good_list'
      if(needReload){
        this.current_history_type=type;
        if(type=='post'){
          this.current_history_id=id;
          data.post_id=id
        }      
        else{
          data.post_id=this.articleId;
          data.post_good_id=id;
          this.current_history_id=id;
        }
      }
      else{
        if(type=='post'){
          data.post_id=this.current_history_id;
        }
        else{
          data.post_id=this.articleId;
          data.post_good_id=this.current_history_id;
        }
      }     
      
      
      let res = await api.get(this, {
        path: 'cm.php',
        api: url,
        params: data
      })
      res = res.body
      this.loadingHistory = false;
      this.continueSearching = false;
      if (res.status == 'ok') {
        if(needReload){
          this.historyRecords=res.result;
        }
        else{
          this.continueSearching=false;
          if(res.result.length)
            this.historyRecords.push(...res.result);
        }
        this.hasMoreHistory = res.result.length >= 10;
      }
    },
    loadMoreHistory() {
      this.getHistory(this.current_history_id, this.current_history_type, false);
    },
    async getFollows(){
      let res = await api.get(this, {
        path: 'cm.php',
        api: 'get_my_followed_list'
      })
      res = res.body
      if (res.status == 'ok') {
        let followes = res.result;
        if(followes.length==0)
          this.followed = false;
        else{
          let a = followes.filter(i=>i.account_id==this.detail.account_id);
          this.followed=a.length>0;
        }
      }
    },
    toggleFollow(){
      let url = ''
      if(this.followed){
          url = 'unfollow';
        }
        else{
          url = 'follow';
        }
        this.followed=!this.followed;
      api.post(this, {
        path: 'cm.php',
        api: url,
        data: {
          following_account_id:this.detail.account_id
        }
      })
    },
    caroulChange(currentIndex) {
      this.imageIndex = currentIndex
    },
    async toggleCollect(){
      let url = ''
      if(this.detail.faved==1){
          url = 'cancel_fav_post';
          this.detail.faved=0;
          this.collectclicked=true;
          setTimeout(()=>{
            this.collectImageSrc=require('@/assets/images/collect.png')
          },500)
          setTimeout(()=>{
            this.collectclicked=false;
          },1000)
        }
        else{
          url = 'fav_post';
          this.detail.faved=1;
          this.collectclicked=true;
          setTimeout(()=>{
            this.collectImageSrc=require('@/assets/images/collect-full.png')
          },500)
          setTimeout(()=>{
            this.collectclicked=false;
          },1000)
        }
      let res = await api.post(this, {
        path: 'cm.php',
        api: url,
        data: {
          post_id:this.articleId
        }
      })
      res = res.body
      if (res.status == 'ok') {
        let t = +this.detail.collections_count;
        if(this.detail.faved==1){
          this.detail.collections_count=t+1;
        }
        else{
          this.detail.collections_count=t-1;
        }
      }
    },
    async toggleLike(c,type){
      let url = '';
      let id = '';
      if(type=='post'){
        id = c.post_id;
        if(c.liked==1){
          url = 'cancel_like';
          c.liked=0;
          this.agreeclicked=true;
          setTimeout(()=>{
            this.agreeImageSrc=require('@/assets/images/agree.png')
          },500)
          setTimeout(()=>{
            this.agreeclicked=false;
          },1000)
        }
        else{
          url = 'like';
          c.liked=1;
          this.agreeclicked=true;
          setTimeout(()=>{
            this.agreeImageSrc=require('@/assets/images/agree-full.png')
          },500)
          setTimeout(()=>{
            this.agreeclicked=false;
          },1000)
        }
      }
      else{
        id = c.comment_id;
        if(c.liked==1){
          url = 'cancel_like';
          c.liked=0;
          c.agreeclicked=true;
          setTimeout(()=>{
            c.agreeImageSrc=require('@/assets/images/agree.png')
            this.$forceUpdate();
          },500)
          setTimeout(()=>{
            c.agreeclicked=false;
            this.$forceUpdate();
          },1000)
        }
        else{
          url = 'like';
          c.liked=1;
          c.agreeclicked=true;
          setTimeout(()=>{
            c.agreeImageSrc=require('@/assets/images/agree-full.png');
            this.$forceUpdate();
          },500)
          setTimeout(()=>{
            c.agreeclicked=false;
            this.$forceUpdate();
          },1000)
        }
      }
      let res = await api.post(this, {
        path: 'cm.php',
        api: url,
        data: {
          target_type:type,
          target_id:id
        }
      })
      res = res.body
      if (res.status == 'ok') {
        let t = +c.likes_count;
        if(c.liked==1){
          c.likes_count=t+1;
        }
        else{
          c.likes_count=t-1;
        }
      } 
    },
    handleImageError(e){
      e.target.src=require('@/assets/images/joyLogoL.png');
      e.target.onerror = null;
    },
    replyComments(r,top_comment_id,parent_comment_id,index){
      if(!r && !this.showReplyFull){
        this.current_comment={}
      }
      else{
        this.current_comment=r?r:{}
      }
      this.current_comment_index=index;
      this.top_comment_id=top_comment_id?top_comment_id:'0';
      this.parent_comment_id=parent_comment_id?parent_comment_id:'0';
      this.showReplyFull=true
    },
    async getComments(id,comment_id){
      let data = {
        post_id:id,
        page:1,
        limit:10
      }
      if(comment_id!='-1')
        data.top_comment_id=comment_id
      let res = await api.get(this, {
        path: 'cm.php',
        api: 'get_comment_list',
        params: data
      })
      res = res.body
      if (res.status == 'ok') {
        this.comments=res.result.filter((i)=>{
          return i['parent_comment_id']=='0'
        })

        this.comments.forEach((p)=>{
          p.agreeclicked=false;
          p.collectclicked=false;
          p.agreeImageSrc=p.liked==1? require('@/assets/images/agree-full.png'):require('@/assets/images/agree.png');
          p.children=res.result.filter((i)=>{
            return i.parent_comment_id==p.comment_id || i.top_comment_id==p.comment_id
          })
        })

        console.log('comments',this.comments)
      }
    },
    async getLocation(){
      let res = await api.get(this, {
        path: 'cm.php',
        api: 'get_location',
      })
      res = res.body
      if (res.status == 'ok') {
        console.log('location',res.result);
        this.location.name = res.result.ip_province;
      }
    },
    async getDetail(){
      let data = {
        post_id:this.articleId
      }
      let res = await api.get(this, {
        path: 'cm.php',
        api: 'get_post_detail',
        params: data
      })
      res = res.body
      if (res.status == 'ok') {
        this.detail = res.result;
        if(this.detail.type!='0' && this.detail.merchant_info){
          let id = this.detail.merchant_info.id;
          this.getMerchant(id)
        }
        this.collectImageSrc=this.detail.faved==1? require('@/assets/images/collect-full.png'):require('@/assets/images/collect.png');
        this.agreeImageSrc = this.detail.liked==1? require('@/assets/images/agree-full.png'):require('@/assets/images/agree.png')
        this.getFollows();
        this.generateContent(this.detail.content);
        //this.article_content=this.detail.content;
        this.generateAtUserContent();
        this.getComments(this.articleId,'-1');
        this.$nextTick(()=>{
          if(this.detail.media_list && this.detail.media_list[0].type=='video'){
            let player = new Player({
              id: 'videoplayer',
              url: this.detail.media_list[0].url,
              height:'100%',
              lang:'zh',
              ignores: ["cssfullscreen"],
              pip: { 
                position: Plugin.POSITIONS.CONTROLS_RIGHT,
                index: 1,
                showIcon: true
              },
              playbackRate: {
                list: [{
                  text: '0.5X',
                  rate: 0.5
                }, {
                  text: '0.75X',
                  rate: 0.75
                }, {
                  text: '1X',
                  iconText: '倍速',
                  rate: 1
                }, {
                  text: '1.5X',
                  rate: 1.5
                }, {
                  text: '2X',
                  rate: 2
                }]
              }
            });
          }
        })
      }
    },
    getMerchant(id){
      api.getMerchantDetail(this, { id: id }).then((res) => {
        let theMerchant = res.body.result;
        this.adminlist = theMerchant.administrator_list;
        if(this.adminlist.filter(i=>i.account_id==this.account_id).length){
          this.merchant_admin=true;
        }
      })
    },
    generateAtUserContent(){
       if(this.article_content.indexOf('<a href="#quilluser"')>-1){
        const regex = /@([^<]+)(?=<\/a>)/g;
        let matches = this.article_content.match(regex);
        if(matches!=null && matches.length>0){
          let arr = matches.map((i)=>{
            return i
          });
          arr = [...new Set(arr)];
          arr.forEach((m)=>{
              if(m){
                let reg = new RegExp(`<a href="#quilluser".*${m}</a>`,'g');
                let url = '#';
                this.article_content=this.article_content.replace(reg,'<a target="_blank" class="rich-text-a" href="'+url+'">'+m+'</a>');
              }
            })
        }
       }
       else{
        const regex = /@\S+/g;
        let matches = this.article_content.match(regex);
        if(matches!=null && matches.length>0){
          let arr = matches.map((i)=>{
            return i
          });
          arr = [...new Set(arr)];
          arr.forEach((m)=>{
              if(m){
                let reg = new RegExp(m);
                let url = '#';
                this.article_content=this.article_content.replace(reg,'<a target="_blank" class="rich-text-a" href="'+url+'">'+m+'</a>');
              }
          })
        }
       }     
    },
    extractAnchors(text) {
      const regex = /#[^#\s]+(?=#|\s|$)/g;
      const anchors = [];
      let match;
      
      while ((match = regex.exec(text)) !== null) {
          // 检查前面是否有引号
          const prevChar = text[match.index - 1];
          if (prevChar !== '"' && prevChar !== "'") {
              anchors.push(match[0]);
          }
      }
      return anchors;
    },
    generateContent(content){
      content = content.replace(/\n/g,'<br />')
      content = content.replace(/\[话题]#/g,'')
      if(content.indexOf('<a href="#quilltag"')>-1){
        const regex = />#([^<]+)(?=<\/a>)/g;
        let matches = content.match(regex);
        console.log('match',matches)
        if(matches==null || matches.length==0){
          this.article_content=this.article_content+content;
        }
        else{
          let arr = matches.map((i)=>{
            return i.substring(1)
          });
          arr = [...new Set(arr)];
          let s = content.replace(/\n/g,'<br />');
          arr.forEach((m)=>{
            if(m){
              let reg = new RegExp(`<a href="#quilltag".*${m}</a>`,'g');
              let url = '/explore?tag='+m.replace('#','');
              s=s.replace(reg,'<a target="_blank" class="rich-text-a" href="'+url+'">'+m+'</a>');
            }
          })
          this.article_content=this.article_content+s;
        }
      }
      else{
        this.article_content='<p>';   
        //const regex = /(?:^|[^"'])(#[^#\s]+)(?=#|\s|$)/g
        //const regex = /(?!<a[^>]*href="[^"]*")(#[^#\s]+)/g;
        //let matches = content.match(regex);
        let matches = this.extractAnchors(content);
        if(matches==null || matches.length==0){
          this.article_content=this.article_content+content;
        }
        else{
          let arr = matches.map((i)=>{
            return i
          });
          arr = [...new Set(arr)];
          let s = content.replace(/\n/g,'<br />');
          arr.forEach((m)=>{
            if(m){
              let reg = new RegExp(m);
              let url = '/explore?tag='+m.replace('#','');
              s=s.replace(reg,'<a target="_blank" class="rich-text-a" href="'+url+'">'+m+'</a>');
            }
          })
          this.article_content=this.article_content+s;
        }
        this.article_content=this.article_content+'</p>';
      }
    },
    async reply(){
      //console.log('comindex',this.current_comment_index)
      let data = {
        post_id:this.detail.post_id,
        top_comment_id:this.top_comment_id,
        parent_comment_id:this.parent_comment_id,
        content:this.newMessage,
        visibility:0,
        location:this.location
      }

      let res = await api.post(this, {
        path: 'cm.php',
        api: 'add_comment',
        data: data
      })
      res = res.body
      if (res.status == 'ok') {
        this.newMessage=''
        if(this.parent_comment_id=='0')
          this.comments.unshift(res.result);
        else{
          if(!this.comments[this.current_comment_index].children){
            this.comments[this.current_comment_index].children=[]
          }
          this.comments[this.current_comment_index].children.unshift(res.result);
          this.comments[this.current_comment_index].child_comments_count=this.comments[this.current_comment_index].children.length
        }
        this.showReplyFull=false;
      }
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(datestring==today_string)
        return '今天';
      if(datestring==yest_string)
        return '昨天';
      return this.$moment(new Date(datestring)).format('YYYY-MM-DD')
    },
    insertEmoji(emoji){
        const input = this.$refs.inputRef.$el.querySelector('input')
        const start = input.selectionStart
        const end = input.selectionEnd

        const str = this.newMessage
        const newValue = str.slice(0, start) + emoji + str.slice(end)
        this.newMessage = newValue

        // 等 DOM 更新后恢复光标位置
        this.$nextTick(() => {
          const newPos = start + 1
          input.focus()
          input.setSelectionRange(newPos, newPos)
        })
        this.showReplyFull=false;
        
    },
    formatDate(t){
      let d = new Date(t);
      let year = d.getFullYear().toString();
      let month = (d.getMonth()+1)<10?'0'+(d.getMonth()+1).toString():(d.getMonth()+1).toString();
      let day = d.getDate()<10?'0'+d.getDate().toString():d.getDate().toString();
      //let hour = d.getHours().toString();
      //let min = d.getMinutes().toString();
      if(year==new Date().getFullYear().toString()){
        year=''
      }
      else{
        year=year+'-'
      }
      return year+month+'-'+day;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .video-wrapper{
    width: 616px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: black;
  }
  .article-content{
    margin-bottom: 5px;
  }
.relation_product{
  cursor: pointer;
  width:100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin:5px 0;
  background:#eee;
  border-radius: 3px;
  padding:10px;
}
.relation_product_big{
  cursor: pointer;
  width:50%;
  text-align: center;
  position: relative;
  margin:10px 0;
  padding:0 10px 10px;
  border-bottom:1px solid #f6f6f6;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.relation_product_big:nth-of-type(2n-1){
  border-right:1px solid #f6f6f6;
}
.relation_product_info{
  flex:1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  height: 100%;
}
  .imgdivwrapper{
    height:100%;
    position: relative;
  }
  .right-article-detail{
    overflow: auto;
    height:calc(100% - 110px)
  }
  .right-article-detail::-webkit-scrollbar{
    display: none;
  }
  .history-row{
    border-bottom: 1px solid #ebebeb;
    height:40px;
    line-height: 40px;
    display: flex;
  }
  .history-body{
    height:400px;
    width: 100%;
    overflow: auto;
  }
  .history-body::-webkit-scrollbar{
    display: none;
  }
  .el-icon-star-on{
    font-size: 28px;
  }
  .el-icon-star-off{
    font-size: 24px;;
  }
  .header {
    border-bottom: 1px solid #d7d7d7;
  }
  .crumbs {
    margin-top: 34px;
    max-width: 1200px;
    margin: 34px auto 10px;
  }
  .main-content {
    padding-top: 70 + 116px;
    .select-shop {
      max-width: 760px;
      margin: 0 auto;
    }
    .publish-task-product {
      max-width: 1140px;
      margin: 0 auto;
    }
  }

  @media screen and (max-width:1024px){
    .main-content {
      padding-top: 50px;
    }
  }
  .article-comment{
    display: flex;
    margin-bottom:16px;
  }
  .product-price{
    font-size:12px;
    color:#333;
    &.discounted{
      color:#ff4650;
    }
  }
  .product-name{
    line-height: 15px;
    color:#333;
    text-overflow: ellipsis;
    height: 32px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    word-break: break-word;
  }
  .emoji-item {
  cursor: pointer;
  font-size: 24px;
  padding: 4px 0px 6px 0px;
  margin:5px 0;
  border-radius: 4px;
  width:40px;
  transition: background 0.2s;
  text-align: center;
}

.emoji-item:hover {
  background: #000;
}
.emoji-wrapper{
  padding:10px;
  height: 250px;
  width:350px;
  overflow-y: auto;
}
.emoji-wrapper::-webkit-scrollbar {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleDetail.vue